__turbopack_context__.v({
  "animate": "Sidebar-module-scss-module__XcED4q__animate",
  "closeIcon": "Sidebar-module-scss-module__XcED4q__closeIcon",
  "open": "Sidebar-module-scss-module__XcED4q__open",
  "sidebar": "Sidebar-module-scss-module__XcED4q__sidebar",
});
